import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  sendOpenItineraryPanelEvent,
  sendApplyFiltersEvent,
  sendInitialSearchEvent,
  getParamsPersonalizationEvent,
} from './functions';

export const PersonalizationContext = React.createContext({});

const PersonalizationContextProvider = ({ children }) => {
  const initialState = {
    sendOpenItineraryPanelEvent,
    sendApplyFiltersEvent,
    sendInitialSearchEvent,
    getParamsPersonalizationEvent,
  };

  const [contextState] = useState(initialState);

  return (
    <PersonalizationContext.Provider value={contextState}>
      {children}
    </PersonalizationContext.Provider>
  );
};

PersonalizationContextProvider.propTypes = {
  children: PropTypes.node,
};

export default PersonalizationContextProvider;
